import { getCurrentToken } from "./axiosConfig";

const API_BASE = import.meta.env.VITE_API_BASE_URL;

export async function apiFetch(endpoint: string, options: RequestInit = {}) {

  const token = getCurrentToken();

  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`
    };
  }

  const res = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  // 🔥 GLOBAL AUTH, MFA, AND INACTIVITY DETECTION
  if (res.status === 403 || res.status === 401) {
    try {
      const data = await res.clone().json();

      // 1. Check for specific MFA requirement
      if (res.status === 403 && data?.details?.code === "MFA_REQUIRED") {
        localStorage.removeItem("mfa_verified");
        window.dispatchEvent(new CustomEvent("mfa-required", { detail: data.details }));
      }
      // 2. NEW: Check for backend Inactivity flag
      else if (res.status === 403 && data?.details?.code === "ACCOUNT_INACTIVE") {
        window.dispatchEvent(new CustomEvent("session-expired", {
          detail: { message: data.details.message }
        }));
      }
      // 3. Fallback for generic 401 Unauthorized (dead token)
      else if (res.status === 401) {
        window.dispatchEvent(new CustomEvent("session-expired"));
      }
    } catch (err) {
      // Ignore JSON parsing errors for non-JSON 403s
    }
  }

  return res;
}